<!--
 * @Author: huangyan
 * @Date: 2021-08-09 10:18:31
 * @LastEditors: huangyan
 * @LastEditTime: 2021-09-08 12:07:27
 * @Description:
-->
<template>
    <div id="app">
        <router-view :key="this.$route.path" v-if="isRouterAlive" />
        <!--底部模块-->
        <!--<foot></foot>-->
    </div>
</template>

<script>
    export default {
        name: 'App',
        provide() {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isRouterAlive: true
            }
        },
        methods: {
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        },
        computed: {
            //	key(){
            //
            //		var r=this.$route.path+ +Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
            //		return r
            //	}
        }
    }
</script>

<style lang="scss">
    // @import url("./assets/iconfontNew/iconfont.css");
    #app {
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
        //   font-family: "pu" "Microsoft YaHei","Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","微软雅黑",Arial,sans-serif;
        font-family: "Microsoft YaHei", "Helvetica Neue", "Helvetica", "Arial";
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #333333;
    }

    .mycon {
        width: 1190px;
        margin: 0 auto;
    }

    * {
        box-sizing: border-box;
    }

    .chat-box {
        text-align: center;

        .chat-img img {
            width: 250px;
            height: 250px;
        }

        .chat-text {
            color: #5DAF3F;
            font-size: 16px;
            margin-top: 24px;
        }
    }

    .el-image-viewer__close {
        color: #fff;
    }

    .login-look-price {
        margin-top: 4px;
        font-size: 12px;
        color: #333;

        .iconfont {
            font-size: 12px;
            color: #E43931;
        }

        .btn {
            margin-left: 10px;
            color: #E43931;
        }
    }
</style>
